<script setup lang="ts">
/** Appendix C — Senior Management in place of BO (Individual signatory). */
import { inject, computed } from 'vue';
import SmParticularsTable from './parts/SmParticularsTable.vue';
import BoAppendixSigners from './parts/BoAppendixSigners.vue';
import { BO_APPENDIX_DOC_CTX } from './boAppendixContext';
import {
  normalizeSmReasonId,
  smReasonLabel,
  type BoSmReasonId,
} from './mapBoJsonToAppendix';

const ctx = inject(BO_APPENDIX_DOC_CTX)!;
const reasonId = computed(() => normalizeSmReasonId(ctx.valueOf('ba05_sm_reason_id')));

function mark(on: boolean) { return on ? '☒' : '☐'; }
function isOn(id: 1 | 2 | 3) { return reasonId.value === id; }

/** Q13 SMReasonId 1/2/3 — 라디오식. 선택 시 reason 텍스트도 동기화 */
function toggleReason(id: 1 | 2 | 3) {
  const next: BoSmReasonId = reasonId.value === id ? 0 : id;
  ctx.setFieldValue('ba05_sm_reason_id', next ? String(next) : '');
  ctx.setFieldValue('ba05_sm_reason', next ? smReasonLabel(next) : '');
}
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title">Appendix C</p>
    <p class="doc-p" style="text-align:center; margin-top:-4px">
      (The company has no beneficial owner, beneficial owner cannot be identified &amp;<br />
      in the process of obtaining beneficial ownership information)
    </p>

    <SmParticularsTable key-prefix="ba05_" />

    <p class="doc-p" style="padding-top:10px">
      <b>13.</b> To state the reason for naming the senior management in place of the beneficial owner<br />
      <span style="font-size:11px; color:#555">[Note: Please state either one of the reasons as per paragraph 2 of the notice]</span>
    </p>
    <p class="doc-p" style="padding-left:8px">
      <span class="doc-toggle" @click.stop="toggleReason(1)">{{ mark(isOn(1)) }} The company has no beneficial owner</span><br />
      <span class="doc-toggle" @click.stop="toggleReason(2)">{{ mark(isOn(2)) }} Beneficial owner cannot be identified</span><br />
      <span class="doc-toggle" @click.stop="toggleReason(3)">{{ mark(isOn(3)) }} In the process of obtaining ownership information</span>
    </p>

    <p class="doc-p" style="padding-top:14px">I hereby declare as follows:</p>
    <p class="doc-p" style="font-style:italic; padding-left:8px">
      “I hereby confirmed that the facts and information stated in this letter are true and to the best of my knowledge and belief.”
    </p>
    <BoAppendixSigners var-key="BA05" />
    <p class="doc-p" style="padding-top:4px">[SENIOR MANAGEMENT]</p>
  </div>
</template>

<style src="./boAppendixDoc.css"></style>
